var CK_CIUDADES={"Amazonas": ["Leticia", "Puerto Nariño"], "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Apartadó", "Turbo", "Rionegro", "Sabaneta", "Caldas", "La Estrella", "Copacabana", "Girardota", "Caucasia", "Chigorodó", "Carepa", "Necoclí", "Yarumal", "Puerto Berrío", "Marinilla", "La Ceja", "Guarne", "Santa Fe de Antioquia", "Segovia", "El Bagre"], "Arauca": ["Arauca", "Saravena", "Tame", "Arauquita", "Fortul"], "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Sabanalarga", "Puerto Colombia", "Galapa", "Baranoa", "Sabanagrande", "Palmar de Varela"], "Bogotá D.C.": ["Bogotá"], "Bolívar": ["Cartagena", "Magangué", "Turbaco", "Arjona", "El Carmen de Bolívar", "Mompós", "San Juan Nepomuceno", "Santa Rosa del Sur"], "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá", "Paipa", "Villa de Leyva", "Puerto Boyacá", "Moniquirá", "Garagoa"], "Caldas": ["Manizales", "La Dorada", "Chinchiná", "Villamaría", "Riosucio", "Anserma", "Manzanares", "Salamina"], "Caquetá": ["Florencia", "San Vicente del Caguán", "Puerto Rico", "El Doncello"], "Casanare": ["Yopal", "Aguazul", "Villanueva", "Tauramena", "Paz de Ariporo", "Monterrey"], "Cauca": ["Popayán", "Santander de Quilichao", "Puerto Tejada", "Patía", "Guapi", "Piendamó", "Corinto", "Miranda"], "Cesar": ["Valledupar", "Aguachica", "Agustín Codazzi", "La Jagua de Ibirico", "Bosconia", "El Copey", "Curumaní", "Chimichagua"], "Chocó": ["Quibdó", "Istmina", "Tadó", "Riosucio", "Bahía Solano", "Nuquí"], "Córdoba": ["Montería", "Cereté", "Lorica", "Sahagún", "Planeta Rica", "Montelíbano", "Tierralta", "Ciénaga de Oro", "Chinú", "Puerto Libertador"], "Cundinamarca": ["Soacha", "Fusagasugá", "Facatativá", "Zipaquirá", "Chía", "Mosquera", "Madrid", "Funza", "Cajicá", "Girardot", "Ubaté", "Sibaté", "Tocancipá", "La Calera", "Cota", "Tenjo", "Villeta", "Anapoima", "Silvania"], "Guainía": ["Inírida"], "Guaviare": ["San José del Guaviare", "El Retorno", "Calamar"], "Huila": ["Neiva", "Pitalito", "Garzón", "La Plata", "Campoalegre", "Gigante", "Palermo"], "La Guajira": ["Riohacha", "Maicao", "Uribia", "Manaure", "San Juan del Cesar", "Villanueva", "Fonseca", "Albania"], "Magdalena": ["Santa Marta", "Ciénaga", "Fundación", "El Banco", "Plato", "Zona Bananera", "Aracataca", "Pivijay"], "Meta": ["Villavicencio", "Acacías", "Granada", "Puerto López", "San Martín", "Puerto Gaitán", "Restrepo", "Cumaral"], "Nariño": ["Pasto", "Tumaco", "Ipiales", "Túquerres", "La Unión", "Samaniego", "Sandoná", "Barbacoas"], "Norte de Santander": ["Cúcuta", "Ocaña", "Villa del Rosario", "Los Patios", "Pamplona", "Tibú", "El Zulia", "Sardinata"], "Putumayo": ["Mocoa", "Puerto Asís", "Orito", "Valle del Guamuez", "Villagarzón", "Sibundoy"], "Quindío": ["Armenia", "Calarcá", "Montenegro", "La Tebaida", "Quimbaya", "Circasia", "Filandia", "Salento"], "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal", "La Virginia", "Marsella", "Belén de Umbría", "Quinchía"], "San Andrés y Providencia": ["San Andrés", "Providencia"], "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja", "San Gil", "Socorro", "Málaga", "Barbosa", "Vélez", "Sabana de Torres", "Lebrija", "Puerto Wilches"], "Sucre": ["Sincelejo", "Corozal", "Sampués", "San Marcos", "Tolú", "Since", "Majagual", "San Onofre"], "Tolima": ["Ibagué", "Espinal", "Melgar", "Honda", "Líbano", "Chaparral", "Mariquita", "Guamo", "Purificación", "Flandes"], "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Cartago", "Buga", "Jamundí", "Yumbo", "Candelaria", "Florida", "Pradera", "Zarzal", "Roldanillo", "Sevilla", "El Cerrito", "Caicedonia"], "Vaupés": ["Mitú"], "Vichada": ["Puerto Carreño", "La Primavera", "Santa Rosalía"]};
var CK_PROV={"Amazonas": "AMA", "Antioquia": "ANT", "Arauca": "ARA", "Atlántico": "ATL", "Bogotá D.C.": "DC", "Bolívar": "BOL", "Boyacá": "BOY", "Caldas": "CAL", "Caquetá": "CAQ", "Casanare": "CAS", "Cauca": "CAU", "Cesar": "CES", "Chocó": "CHO", "Córdoba": "COR", "Cundinamarca": "CUN", "Guainía": "GUA", "Guaviare": "GUV", "Huila": "HUI", "La Guajira": "LAG", "Magdalena": "MAG", "Meta": "MET", "Nariño": "NAR", "Norte de Santander": "NSA", "Putumayo": "PUT", "Quindío": "QUI", "Risaralda": "RIS", "San Andrés y Providencia": "SAP", "Santander": "SAN", "Sucre": "SUC", "Tolima": "TOL", "Valle del Cauca": "VAC", "Vaupés": "VAU", "Vichada": "VID"};
var EXCK=window.EXCK||(function(){try{return JSON.parse(document.getElementById('ckCfg').textContent);}catch(e){return null;}})()||null;

(function(){
 var $=function(s){return document.querySelector(s);};
 var ck=$('#ck'); if(!ck) return;
 var pesos=function(v){return '$'+String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g,'.');};

 if(!EXCK || !EXCK.packs) return;
 if(!EXCK.variante && typeof EXCK_VARIANTE_FALLBACK!=='undefined')
   EXCK.variante=EXCK_VARIANTE_FALLBACK;
 // La MONEDA sale de la tienda, no escrita a mano: esta hoja la comparten todas
 // las landings de la tienda y la skill se usa en varios paises. Si se hornea
 // 'COP', una tienda en otra moneda le reporta a Meta un valor en la divisa
 // equivocada y el ROAS sale mal SIN QUE NADIE LO NOTE: el evento llega igual.
 var MONEDA = EXCK.moneda ||
   (typeof EXCK_MONEDA_SHOP!=='undefined' ? EXCK_MONEDA_SHOP : 'COP');
 if(!EXCK.ciudades) EXCK.ciudades=CK_CIUDADES;
 if(!EXCK.prov)     EXCK.prov=CK_PROV;
 var UNI=EXCK.unidad||'unidad';   // 'frasco', 'caja', lo que sea el producto

 var esPagina=ck.classList.contains('ck-pagina');
 var msg=$('#ckMsg');

 // ── tarjetas de oferta: en la pagina se pintan desde la config ────
 var cajaPacks=$('#ckPacks');
 if(cajaPacks && !cajaPacks.children.length){
   var ns=Object.keys(EXCK.packs).sort(function(a,b){return a-b;});
   cajaPacks.innerHTML=ns.map(function(n,i){
     var p=EXCK.packs[n], rec=(i===1), mejor=(i===ns.length-1 && ns.length>1);
     var und=Math.round(p.precio/(+n));
     return '<label class="ck-pack'+(rec?' es-rec':'')+'" data-n="'+n+'">'+
       '<input type="radio" name="ck_pack" value="'+n+'"'+(rec?' checked':'')+'>'+
       '<span class="ck-rad" aria-hidden="true"></span>'+
       '<img class="ck-pimg" src="'+p.img+'?width=240" width="120" height="120" '+
         'alt="'+p.etiq+'" loading="lazy" decoding="async">'+
       '<span class="ck-ptx"><b>'+p.etiq+'</b>'+
         '<i>'+pesos(und)+' por '+UNI+'</i><u>'+(p.sub||'')+'</u></span>'+
       '<span class="ck-pre">'+(p.antes>p.precio?'<s>'+pesos(p.antes)+'</s>':'')+
         '<b>'+pesos(p.precio)+'</b>'+
         (p.ahorro?'<span class="ck-ah">Ahorras '+pesos(p.ahorro)+'</span>':'')+'</span>'+
       (rec?'<span class="ck-rec">EL QUE MÁS PIDEN</span>':'')+
       (mejor?'<span class="ck-mejor">Mejor precio por '+UNI+'</span>':'')+
     '</label>';
   }).join('');
 }

 function nPack(){
   var r=ck.querySelector('input[name=ck_pack]:checked');
   return r?r.value:Object.keys(EXCK.packs)[0];
 }
 function pack(){ return EXCK.packs[nPack()]; }
 function precio(){ return pack().precio; }

 // ── abrir / cerrar (solo en modo modal) ───────────────────────────
 function abrir(e){
   if(e){e.preventDefault();e.stopPropagation();}
   ck.hidden=false; ck.classList.add('abierto');
   document.documentElement.classList.add('ck-abierto');
   document.body.classList.add('ck-abierto');
   ck.querySelector('.ck-scroll').scrollTop=0;
   if(window.fbq) fbq('track','InitiateCheckout',
     {content_name:EXCK.producto,value:precio(),currency:MONEDA});
 }
 function cerrar(){
   ck.classList.remove('abierto'); ck.hidden=true;
   document.documentElement.classList.remove('ck-abierto');
   document.body.classList.remove('ck-abierto');
 }
 if(esPagina){
   var qc=new URLSearchParams(location.search).get('c');
   if(qc && EXCK.packs[qc]){
     var r0=ck.querySelector('input[name=ck_pack][value="'+qc+'"]');
     if(r0) r0.checked=true;
   }
   if(window.fbq) fbq('track','InitiateCheckout',
     {content_name:EXCK.producto,value:precio(),currency:MONEDA});
 } else {
   var bc=$('#ckCerrar'); if(bc) bc.addEventListener('click',cerrar);
   document.querySelectorAll('.btn-gatillo').forEach(function(el){
     el.addEventListener('click',abrir,true);
   });
 }
 document.addEventListener('keydown',function(e){
   if(e.key==='Escape' && !esPagina && ck.classList.contains('abierto')) cerrar();
 });

 // ── resumen en vivo ───────────────────────────────────────────────
 function pintar(){
   var p=pack(); if(!p) return;
   var img=$('#ckResImg'); if(img) img.src=p.img+'?width=160';
   var sub=$('#ckResSub'); if(sub) sub.textContent=p.etiq+(p.sub?' · '+p.sub:'');
   $('#ckSub').textContent=pesos(p.antes);
   $('#ckAhorro').textContent='-'+pesos(p.antes-p.precio);
   $('#ckLnAhorro').style.display=(p.antes>p.precio)?'':'none';
   $('#ckTotal').textContent=pesos(p.precio);
   // mismo redondeo a centenas que usa la landing: si no, difieren por pesos
   var dsc=Math.round(p.precio*EXCK.pct/100/100)*100;
   $('#ckOnline').textContent=pesos(p.precio-dsc);
 }
 ck.querySelectorAll('input[name=ck_pack]').forEach(function(r){
   r.addEventListener('change',pintar);
 });
 pintar();

 // ── departamento -> ciudad ────────────────────────────────────────
 var selD=$('#ck_departamento'), selC=$('#ck_ciudad');
 if(selD) selD.addEventListener('change',function(){
   var ls=EXCK.ciudades[selD.value]||[];
   selC.innerHTML='<option value="">'+(ls.length?'Seleccionar…':'Primero el departamento')+'</option>'
     +ls.map(function(c){return '<option value="'+c+'">'+c+'</option>';}).join('');
   selC.disabled=!ls.length;
 });

 // ── validacion ────────────────────────────────────────────────────
 var REQ=['nombre','apellido','whatsapp','direccion','extra','departamento','ciudad'];
 function campo(n){ return $('#ck_'+n); }
 function marcar(n,txt){
   var c=campo(n); if(!c) return;
   var caja=c.closest('.ck-campo'); if(!caja) return;
   var e=caja.querySelector('.ck-err');
   if(txt){ caja.classList.add('mal'); if(e){e.textContent=txt;e.hidden=false;} }
   else   { caja.classList.remove('mal'); if(e){e.hidden=true;} }
 }
 function datos(){
   var d={};
   ['nombre','apellido','whatsapp','cedula','email','direccion','extra',
    'departamento','ciudad'].forEach(function(n){
     var c=campo(n); d[n]=c?c.value.trim():'';
   });
   d.web=($('#ck_web')||{}).value||'';     // honeypot
   return d;
 }
 function valido(){
   var d=datos(), ok=true;
   REQ.forEach(function(n){
     if(!d[n]){ marcar(n,'Falta este dato'); ok=false; } else marcar(n,'');
   });
   var tel=d.whatsapp.replace(/\D/g,'');
   if(d.whatsapp && tel.length<10){ marcar('whatsapp','Son 10 dígitos'); ok=false; }
   if(d.email && d.email.indexOf('@')<0){ marcar('email','Correo inválido'); ok=false; }
   if(!ok){
     msg.textContent='Revisa los datos marcados en rojo.'; msg.className='ck-msg mal';
     var pri=ck.querySelector('.ck-campo.mal');
     if(pri) pri.scrollIntoView({behavior:'smooth',block:'center'});
   }
   return ok?d:null;
 }

 // ── BOTON 1 · contra entrega -> el Worker crea el pedido ──────────
 $('#ckCod').addEventListener('click',function(){
   var d=valido(); if(!d) return;
   var b=this, bOn=$('#ckOn');
   b.disabled=true; if(bOn) bOn.disabled=true;
   msg.textContent='Creando tu pedido…'; msg.className='ck-msg';
   var p=pack(), n=parseInt(nPack(),10);
   fetch(EXCK.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},
     body:JSON.stringify({
       tienda:EXCK.tienda, variante:EXCK.variante, cantidad:n,
       nombre:d.nombre, apellido:d.apellido, whatsapp:d.whatsapp, cedula:d.cedula,
       email:d.email, direccion:d.direccion, extra:d.extra,
       departamento:d.departamento, ciudad:d.ciudad,
       provincia:(EXCK.prov[d.departamento]||''),
       envio_titulo:'Envío gratis', envio_costo:0,
       descuento_codigo:(p.codigo||('PACK'+n)), descuento_monto:(p.antes-p.precio),
       origen:location.pathname, web:d.web
     })})
   .then(function(r){return r.json();})
   .then(function(r){
     if(!r||!r.ok) throw new Error((r&&r.error)||'no se pudo crear el pedido');
     // Shopify NO dispara Purchase en pedidos creados por API: se dispara aca,
     // con eventID para que la CAPI lo deduplique.
     if(window.fbq) fbq('track','Purchase',
       {content_name:EXCK.producto,value:p.precio,currency:MONEDA,num_items:n},
       {eventID:'ord-'+(r.id||r.pedido)});
     exito(r.pedido);
   })
   .catch(function(e){
     b.disabled=false; if(bOn) bOn.disabled=false;
     msg.textContent='No pudimos crear el pedido. Escríbenos por WhatsApp y lo tomamos a mano.';
     msg.className='ck-msg mal';
     if(window.console) console.warn('[checkout]',e);
   });
 });

 // ── BOTON 2 · en linea -> carrito + checkout nativo de Shopify ────
 // Shopify dispara Purchase al completarse: aca NO se dispara (se duplicaria).
 $('#ckOn').addEventListener('click',function(){
   var d=valido(); if(!d) return;
   var b=this; b.disabled=true;
   msg.textContent='Te llevamos al pago seguro…'; msg.className='ck-msg';
   var n=parseInt(nPack(),10);
   fetch('/cart/clear.js',{method:'POST'})
    .then(function(){
      return fetch('/cart/add.js',{method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:EXCK.variante,quantity:n}]})});
    })
    .then(function(){
      var q=['discount='+encodeURIComponent((pack()||{}).codigo||EXCK.codigo),
             'checkout[email]='+encodeURIComponent(d.email||''),
             'checkout[shipping_address][first_name]='+encodeURIComponent(d.nombre),
             'checkout[shipping_address][last_name]='+encodeURIComponent(d.apellido),
             'checkout[shipping_address][address1]='+encodeURIComponent(d.direccion),
             'checkout[shipping_address][address2]='+encodeURIComponent(d.extra),
             'checkout[shipping_address][city]='+encodeURIComponent(d.ciudad),
             'checkout[shipping_address][province]='+encodeURIComponent(d.departamento),
             'checkout[shipping_address][country]=Colombia',
             'checkout[shipping_address][phone]='+encodeURIComponent('+57'+d.whatsapp.replace(/\D/g,''))
            ].join('&');
      location.href='/checkout?'+q;
    })
    .catch(function(){
      b.disabled=false;
      msg.textContent='No pudimos abrir el pago en línea. Probá con contra entrega.';
      msg.className='ck-msg mal';
    });
 });

 function exito(num){
   ck.querySelector('.ck-in').innerHTML=
     '<div class="ck-ok"><div class="ck-ok-ic">&#10004;</div>'+
     '<h2>¡Pedido confirmado!</h2>'+
     '<p>Tu número de pedido es <span class="num">'+(num||'')+'</span></p>'+
     '<p>Te escribimos por WhatsApp para confirmar la entrega. '+
     'Pagas en efectivo cuando lo recibas.</p></div>';
   ck.querySelector('.ck-scroll').scrollTop=0;
 }
})();
